import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Column from 'shared/components/atoms/Column';
import RadioButton from 'shared/components/molecules/RadioButton';
import { selectBillingFrequency } from 'Order/selectors';
import { BillingFrequency as BillingFrequencyType } from 'Order/types/orderRecord';
import { updateBillingFrequency } from 'Order/actions';
import { selectQuote } from 'Quotes/selectors';
import { selectCompanyPreferences } from 'User/selectors';

export const BillingFrequency: FC<React.PropsWithChildren<unknown>> = () => {
  const dispatch = useDispatch();
  const quote = useSelector(selectQuote);
  const companyPreferences = useSelector(selectCompanyPreferences);
  
  let billingFrequency = useSelector(selectBillingFrequency);

  // Temp hardcode to enforce billing frequency type by customer ID
  const forceBilledType = true;

  if (forceBilledType) {
    const forceMonthlyBilled = companyPreferences?.enforce_monthly_billing === true && companyPreferences?.id === quote.customerId;
    billingFrequency = forceMonthlyBilled ? BillingFrequencyType.Monthly : BillingFrequencyType.Quarterly;
    dispatch(updateBillingFrequency(billingFrequency));
  }

  return (
    <>
      <div className="row no-gutters pt-4">
        <Column defaultWidth={5} offsetDefaultWidth={1}>Billing frequency *</Column>

        {((forceBilledType && billingFrequency === BillingFrequencyType.Quarterly) || !forceBilledType) &&
        <Column defaultWidth={3} className="pr-3">
          <RadioButton
            id="billing_frequency_quarterly"
            description="Quarterly in advance"
            onClick={() => dispatch(updateBillingFrequency(BillingFrequencyType.Quarterly))}
            selected={billingFrequency === BillingFrequencyType.Quarterly}
          />
        </Column>}

        {((forceBilledType && billingFrequency === BillingFrequencyType.Monthly) || !forceBilledType) &&
        <Column defaultWidth={3}>
          <RadioButton
            id="billing_frequency_monthly"
            description="Monthly in advance"
            onClick={() => dispatch(updateBillingFrequency(BillingFrequencyType.Monthly))}
            selected={billingFrequency === BillingFrequencyType.Monthly}
          />
        </Column>}
      </div>
    </>
  );
};
